import { axiosCustom } from 'common/common.function';
import {
  GetTrackingListInput,
  GetTrackingListOutput,
  JobMailSubscriptionStatusOutput,
  JobMailSubscriptionToggleOutput,
  RequestCountAllOutput,
  RequestCountSelectInput,
  RequestCountSelectOutput,
  RunAllJobsOutput,
  RunSelectedProdInput,
  RunSelectedProdOutput,
} from 'components/form/interfaces/user-admin.interface';

/**
 * @alias 유저의 작업결과 메일 수신여부 토글 API
 * @description 유저의 작업결과 메일 수신여부를 토글합니다. (수신 <-> 수신거부)
 * @returns - 200 { success: true, jobMailYn: boolean }
 * @returns - 400 { success: false, message: '존재하지 않는 유저입니다.' }
 */
export async function jobMailSubscriptionstatus(): Promise<JobMailSubscriptionStatusOutput> {
  const gmptoken = JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
  return await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/user/job-mail/status`, {
    headers: {
      gmptoken,
    },
  });
}

/**
 * @alias 유저의 작업결과 메일 수신여부 토글
 * @description 유저의 작업결과 메일 수신여부를 토글합니다. (수신 <-> 수신거부)
 * @returns - 200 { success: true, jobMailYn: boolean }
 * @returns - 400 { success: false, message: '존재하지 않는 유저입니다.' }
 */
export async function jobMailSubscriptionToggleMutation(): Promise<JobMailSubscriptionToggleOutput> {
  const gmptoken = JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
  return await axiosCustom.post(
    `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/user/job-mail/subscription`,
    {},
    {
      headers: {
        gmptoken,
      },
    },
  );
}

/**
 * @alias 유저의 연동중인 스케줄러 상품리스트 조회
 * @description 유저의 연동중인 스케줄러 상품리스트를 조회합니다.
 * @returns - 200 { success: true, result: TrackingProduct[] }
 * @returns - 400 { success: false, message: '존재하지 않는 유저입니다.' }
 */
export async function getTrackingList(query: GetTrackingListInput): Promise<GetTrackingListOutput> {
  const gmptoken = JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
  return await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/user/tracking-list`, {
    headers: {
      gmptoken,
    },
    params: query,
  });
}

/**
 * @alias 스케줄러 마이페이지 상품별 업데이트
 * @description 스케줄러 마이페이지 상품별 업데이트를 실행합니다.
 * @returns - 200 { success: true }
 * @returns - 400 { success: false, message: '사용 가능한 스케줄러가 없습니다.' }
 */
export async function runSelectedProd(body: RunSelectedProdInput): Promise<RunSelectedProdOutput> {
  const gmptoken = JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
  return await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/batches/user/run-selected-prod`, body, {
    headers: {
      gmptoken,
    },
  });
}

/**
 * @alias 스케줄러 마이페이지 일괄 업데이트
 * @description 스케줄러 마이페이지 일괄 업데이트를 실행합니다.
 * @returns - 200 { success: true }
 * @returns - 400 { success: false, message: '사용 가능한 스케줄러가 없습니다.' }
 */
export async function runAllJobs(): Promise<RunAllJobsOutput> {
  const gmptoken = JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
  return await axiosCustom.post(
    `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/batches/user/run-all-jobs`,
    {},
    {
      headers: {
        gmptoken,
      },
    },
  );
}

/**
 * @alias 유저의 상품별 업데이트 요청 카운트 조회
 * @description 유저의 상품별 업데이트 요청 카운트를 조회합니다.
 * @returns - 200 { success: true, resultList: RequestCountSelectItem[] }
 * @returns - 400 { success: false, message: '존재하지 않는 유저입니다.' }
 */
export async function requestCountSelect(body: RequestCountSelectInput): Promise<RequestCountSelectOutput> {
  const gmptoken = JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
  return await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/user/request-count/select`, body, {
    headers: {
      gmptoken,
    },
  });
}

/**
 * @alias 유저의 스케줄러 일괄 업데이트 요청 카운트 조회
 * @description 유저의 스케줄러 일괄 업데이트 요청 카운트를 조회합니다.
 * @returns - 200 { success: true, resultList: RequestCountSelectItem[] }
 * @returns - 400 { success: false, message: '존재하지 않는 유저입니다.' }
 */
export async function requestCountAll(): Promise<RequestCountAllOutput> {
  const gmptoken = JSON.parse(sessionStorage.getItem('wakeupInfo') || '{}').gmpToken;
  return await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/user/request-count/all`, {
    headers: {
      gmptoken,
    },
  });
}
